import React from "react";

export const getFileIcon = (attachment: string) => {
    switch (attachment.substring(attachment.lastIndexOf(".") + 1)) {
      case "pdf":
        return (
          <i
            className="far fa-file-pdf"
            style={{
              cursor: "pointer",
              color: "rgb(115, 32,28)",
              fontSize: "1.5rem"
            }}
          />
        );
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
      case "bmp":
        return (
          <i
            className="far fa-file-image"
            style={{
              cursor: "pointer",
              color: "rgb(175,121,66)",
              fontSize: "1.5rem"
            }}
          />
        );
      case "doc":
      case "docx":
        return (
          <i
            className="far fa-file-word"
            style={{
              cursor: "pointer",
              color: "rgb(51, 86,153)",
              fontSize: "1.5rem"
            }}
          />
        );
      case "msg":
        return (
          <i
            className="far fa-envelope"
            style={{
              cursor: "pointer",
              color: "rgb(0, 116, 196)",
              fontSize: "1.5rem"
            }}
          />
        );
      case "xls":
      case "xlsx":
        return (
          <i
            className="far fa-file-excel"
            style={{
              cursor: "pointer",
              color: "rgb(5, 111, 56)",
              fontSize: "1.5rem"
            }}
          />
        );
      case "ppt":
      case "pptx":
        return (
          <i
            className="far fa-file-powerpoint"
            style={{
              cursor: "pointer",
              color: "rgb(205, 69, 37)",
              fontSize: "1.5rem"
            }}
          />
        );
      case "zip":
        return (
          <i
            className="far fa-file-archive"
            style={{
              cursor: "pointer",
              color: "#c6a700",
              fontSize: "1.5rem"
            }}
          />
        );
      default:
        return (
          <i
            className="far fa-file"
            style={{
              cursor: "pointer",
              color: "#6c757d",
              fontSize: "1.5rem"
            }}
          />
        );
    }
  };